// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__nUrec","loaderAnim":"styles_loaderAnim__hF9V2","loaderMedium":"styles_loaderMedium__tj-52","loaderSmall":"styles_loaderSmall__dur--"};